import {ERPProviderModel} from "app/models/erp/erp-config.model";
import {LookupModel} from "app/models/shared/lookup.model";
import {TabModel} from "app/models/shared/tab.model";
import {tEmailSettingsTab} from "app/types/email-settings.type";
import {tSettingTab} from "app/types/erp-config.type";
import {
    tMatchingCenterTab,
    tStatementCenterTab,
    tStatementDetailTab
} from "app/types/statement.const.type";
import {tTemplateType} from "app/types/template-setting.type";
import {ErpType} from "./enums";

/**
 * App Config
 */
export const AUTH_SCHEME = 'Bearer ';
export const ACCESS_TOKEN_KEY = 'et';
export const REFRESH_TOKEN_KEY = 'ert';
export const IMAGE_TOKEN_KEY = 'eit';
export const TOKEN_ID_KEY = 'ti';
export const HOME_URL_KEY = 'ehu';
export const REMEMBER_ME_KEY = 'er';
export const USER_INFO = 'usif';
export const DASHBOARD_FILTER = 'df';
export const SELECTED_ERP_TYPE = 'set';
export const SELECTED_ORGANIZATION = 'sorg';
export const PO_APPROVAL_QUERY_STR = 'paq';
export const APP_TOOLTIP = 'app-tooltip';
export const EMAIL_TO_SEND = 'ets';
export const CURRENT_USER = 'cu';
export const SIGNIN_USER = 'su';
export const APP_VERSION = 'ver';
export const PAGE_SIZE = 'psz';
export const SELECTED_COMPANY = 'scomp';
export const SELECTED_REVIEW_GROUP = 'srg';
export const SELECTED_JOB = 'sj';
export const INVOICE_REPORT_DATE = 'ird';
export const CONNECT_LOCATION = 'cl';
export const STATEMENT_INCLUDE_ARCHIVED = 'sia';
/**
 * Shared
 */

export const ALLOWED_FILE_TYPES = ['.jpg', '.jpeg', '.png', '.gif', '.mp4', '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.pdf', '.rtf', '.txt'];
export const ALLOWED_IMAGE_FILE_TYPES = ['.jpg', '.jpeg', '.png', '.gif'];
export const ALLOWED_POWERPOINT_TYPES = ['.ppt', '.pptx'];
export const ALLOWED_VIDEO_TYPE = ['.mp4'];

export const VALIDATION_REGEX = {
    phoneWithoutSpace: /^(04|\+64)\d+\S$/,
    phone: /^[+]?(?=(?:[^\dx]*\d))(?:\(\d+(?:\.\d+)?\)|\d+(?:\.\d+)?)(?:[ -]?(?:\(\d+(?:\.\d+)?\)|\d+(?:\.\d+)?))*(?:[ ]?(?:x|ext)\.?[ ]?\d{1,5})?$/,
    postCode: /^(\d{4})$/,
    location: /^([-+]?)([\d]{1,2})(((\.)(\d+)(,)))(\s*)(([-+]?)([\d]{1,3})((\.)(\d+))?)$/,
    email: /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/
};

export const REGEX = {
    erpConnect: /\/erp-integration\/([a-zA-Z0-9]+)\/connect/
}

export const ERROR = 'Something Bad Happened';

export const SUBSCRIPTION_MESSAGE_FOR_MEMBER = 'Your subscription has expired or reach limit. Please contact your administrator to renew your subscription.';
export const SUBSCRIPTION_MESSAGE_FOR_ADMIN = 'Your subscription has expired or reach limit. Please renew your subscription to continue using this feature.';

export const SETTING_TABS: Array<TabModel<tSettingTab>> = [
    new TabModel<tSettingTab>({
        key: 'erp-integration',
        label: 'ERP Integration',
        visible: true
    }),
    new TabModel<tSettingTab>({
        key: 'import-ap-transactions',
        label: 'Import AP Transactions',
        visible: true
    }),
    new TabModel<tSettingTab>({
        key: 'email-template',
        label: 'Email Settings',
        visible: true
    }),
    // new TabModel<tSettingTab>({
    //   key: 'app-settings',
    //   label: 'App Settings',
    //   visible: false
    // })
];

export const EMAIL_SETTINGS_TABS: Array<TabModel<tEmailSettingsTab>> = [
    new TabModel<tEmailSettingsTab>({
        key: 'email-templates',
        label: 'Email Templates',
        visible: true
    })
];

export const STATEMENT_TABS: Array<TabModel<tStatementCenterTab>> = [
    {
        key: 'statements',
        label: 'Statement Center',
        visible: true
    }
]

export const STATEMENT_DETAIL_TABS: Array<TabModel<tStatementDetailTab>> = [
    {
        key: 'ocr',
        label: 'Preview OCR Results',
        visible: true
    },
    {
        key: 'history-activity',
        label: 'History Activity',
        visible: true
    }
];

export const ERP_PROVIDERS: Array<ERPProviderModel> = [
    new ERPProviderModel({
        value: ErpType.XERO,
        label: 'Xero',
        imageUrl: '/assets/images/xero-logo.png',
        url: '/erp-integration/xero',
        has_upload: false
    }),
    new ERPProviderModel({
        value: ErpType.QUICKBOOKS,
        label: 'Quickbooks',
        imageUrl: '/assets/images/quick-book-logo.png',
        url: '/erp-integration/quick-books',
        has_upload: false
    }),
    new ERPProviderModel({
        value: ErpType.IMPORTED,
        label: 'Upload your data',
        imageUrl: '/assets/icons/upload-cloud.svg',
        url: '/import-ap-transactions',
        has_upload: true,
        show_in_integration: true
    }),
    new ERPProviderModel({
        value: ErpType.VIEWPOINT,
        label: 'Trimble Viewpoint',
        imageUrl: '/assets/images/view-point.png',
        url: '/erp-integration/viewpoint'
    }),
    new ERPProviderModel({
        value: ErpType.TECHONE,
        label: 'TechnologyOne',
        imageUrl: '/assets/images/techone-logo.png',
        url: '/erp-integration/techone'
    }),
    new ERPProviderModel({
        value: ErpType.MYOB,
        label: 'MYOB',
        imageUrl: '/assets/images/myob-logo.png',
        url: '/erp-integration/myob',
        has_upload: false
    }),
    new ERPProviderModel({
        value: ErpType.SAGE,
        label: 'Sage Accounting',
        imageUrl: '/assets/images/sage-logo.svg',
        url: '/erp-integration/sage',
        has_upload: false
    }),
    new ERPProviderModel({
        value: ErpType.D365,
        label: 'D365',
        imageUrl: '/assets/images/d365-logo-v2.png',
        url: '/erp-integration/d365',
        has_upload: false
    }),
    new ERPProviderModel({
        value: ErpType.ACUMATICA,
        label: 'Acumatica',
        imageUrl: '/assets/images/acumatica-logo-v3.png',
        url: '/erp-integration/acumatica',
        has_upload: false
    }),
];

export const TEMPLATE_TYPES: Array<LookupModel<tTemplateType>> = [
    new LookupModel<tTemplateType>({
        value: 'missing-invoice-template',
        label: 'Missing Invoices',
    }),
    new LookupModel<tTemplateType>({
        value: 'awaiting-approval-template',
        label: 'Awaiting Approval',
    }),
];

export const MATCHING_CENTER_TABS: Array<TabModel<tMatchingCenterTab>> = [
    new TabModel<tMatchingCenterTab>({
        key: 'reconciliation_activity',
        label: 'Reconciliation Activity'
    }),
    new TabModel<tMatchingCenterTab>({
        key: 'reconciliation_report',
        label: 'Reconciliation Report'
    }),
    new TabModel<tMatchingCenterTab>({
        key: 'vendor_statement',
        label: 'Vendor Statement'
    }),
    new TabModel<tMatchingCenterTab>({
        key: 'sent_items',
        label: 'Sent Items'
    }),
    new TabModel<tMatchingCenterTab>({
        key: 'activity_timeline',
        label: 'Activity'
    }),
//   new TabModel<tMatchingCenterTab>({
//       key: 'notes',
//       label: 'Notes'
//   }),
];

export const TYPE_DATA: Array<LookupModel<string>> = [
    new LookupModel<string>({
        value: 'INVOICE',
        label: 'Invoice',
    }),
    new LookupModel<string>({
        value: 'CREDIT_NOTE',
        label: 'Credit Note',
    }),
    new LookupModel<string>({
        value: 'PAYMENT',
        label: 'Payment',
    }),
];

export const PAYMENT_STATUS_DATA: Array<LookupModel<string>> = [
    new LookupModel<string>({value: 'PAID', label: 'Paid'}),
    new LookupModel<string>({value: 'UNPAID', label: 'Unpaid'}),
    new LookupModel<string>({value: 'PARTIALLY_PAID', label: 'Partially Paid'}),
];

// Convert to object
export const STATEMENT_STATUS_LABELS = {
    'NOT_CREATED': 'Not Created',
    'FINALIZED': 'Finalized',
    'FULL_MATCH': 'Fully Matched',
    'PARTIAL_MATCH': 'Partially Matched',
    'NOT_MATCH': 'Not Matched',
    'READY': 'Ready for Matching',
    'IN_PROGRESS': 'Extraction In Progress',
    'FAILED': 'Extraction Failed',
    'PENDING': 'AP Items Collecting',
    'AP_ITEMS_FAILED': 'AP Collection Failed',
    'DRAFT': 'Draft',
};

export const MATCHING_STATUS_LABELS = {
    'FINALIZED': 'Finalized',
    'FULL_MATCH': 'Fully Match',
    'PARTIAL_MATCH': 'Partially Match',
    'NOT_MATCH': 'Not Match',
};

export const MATCHING_SUMMARY_HEAD: Array<LookupModel<string>> = [
    new LookupModel<string>({
        value: 'parameter',
        label: 'Parameter'
    }),
    new LookupModel<string>({
        value: 'vendor_statement',
        label: 'Vendor Statement'
    }),
]

export const MATCHING_SUMMARY_PARAMS: Array<LookupModel<string>> = [
    new LookupModel<string>({label: 'Opening Date', value: 'opening_date'}),
    new LookupModel<string>({label: 'Closing Date', value: 'closing_date'}),
    new LookupModel<string>({label: 'Opening Balance', value: 'opening_balance'}),
    new LookupModel<string>({label: 'Closing Balance', value: 'closing_balance'}),
    new LookupModel<string>({label: 'Balance Assertion', value: 'balance_assertion'})
];

export const ERP_EXCHANGE_TOKEN_URLS = [
    'https://identity.xero.com/connect/token',
]

export const LAYOUT_PART = {
    body: '.layout-body main',
    statementDetail: '#statement-detail',
    statementCenter: '#statement-center',
    importApTransactions: '#import-ap-transactions'
}

